import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { baseQueryWithReAuth } from '../../utils/baseQueryWithReAuth';
import endpoints from '../../api/endpoints';

export interface IContactRequest {
  topic: string;
  name: string;
  email: string;
  message: string;
  // honeypot — real users leave this blank
  website?: string;
  // invisible reCAPTCHA v2 token — backend binds request.CaptchaToken
  captchaToken: string;
}

export interface IContactResponse {
  success: boolean;
}

export const contactApi = createApi({
  reducerPath: 'serviceContact',
  baseQuery: baseQueryWithReAuth,
  endpoints: (build) => ({
    submitContact: build.mutation<IContactResponse, IContactRequest>({
      query: (body: IContactRequest) => ({
        url: endpoints.jobs.contact,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useSubmitContactMutation } = contactApi;
